import { useEffect, useRef, useState } from 'react';
import { getBase64FromUrl } from '@shared/lib';
export const useConvertAvatarToBase64 = (avatarUrl?: string) => {
  const [avatarBase64, setAvatarDataUrl] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const isCancelled = useRef(false);
  useEffect(() => {
    if (!isCancelled.current && avatarUrl) {
      setIsLoading(true);
      try {
        getBase64FromUrl(avatarUrl).then(base64Avatar => {
          setAvatarDataUrl(base64Avatar);
        });
      } finally {
        setIsLoading(false);
      }
    }
    return () => {
      isCancelled.current = true;
    };
  }, [avatarUrl]);
  return {
    avatarBase64,
    isLoading
  };
};